import React, { useState } from "react";
import ReactImageMagnify from "react-image-magnify";

const imageUrl = process.env.REACT_APP_IMAGE_BASE_URL

const ImageSection = (props) => {
    const colorId = Number(localStorage.getItem('colorId'));
    const { productDetail, error } = props;
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleVerticalClick = (index) => {
        setCurrentIndex(index);
    };

    const filteredProductSkuDtos = colorId
        ? productDetail?.productSkuDtos?.filter(item => item.colorId === colorId)
        : productDetail?.productSkuDtos;

    const defaultImg = '../../../images/defaultImage.png';

    const currentImage = (
        filteredProductSkuDtos && filteredProductSkuDtos.length > 0 &&
        filteredProductSkuDtos[0]?.productImageDtos?.length > 0
    )
        ? `${imageUrl}${filteredProductSkuDtos[0]?.productImageDtos[currentIndex]?.imgPath}`
        : (
            productDetail?.productImageDtos?.length > 0
                ? `${imageUrl}${productDetail?.productImageDtos[currentIndex]?.imgPath}`
                : defaultImg
        );

    return (
        <>
            {error ? (
                <div>{error}</div>
            ) : (
                <div className="col-lg-5">
                    <div className="image_wrep_main d-sm-flex">
                        <div className="imge_wepper d-sm-block d-none col-sm-2">
                            {(
                                (filteredProductSkuDtos && filteredProductSkuDtos.length > 0 && filteredProductSkuDtos[0]?.productImageDtos?.length > 0)
                                    ? filteredProductSkuDtos[0]?.productImageDtos
                                    : productDetail?.productImageDtos
                            )?.slice(0, 5).map((item, i) => (
                                <div
                                    className={`img_book_wrapper ${i === currentIndex ? 'slick-current' : ''}`}
                                    key={i}
                                    onClick={() => handleVerticalClick(i)}
                                >
                                    <img
                                        src={item?.imgPath ? `${imageUrl}${item.imgPath}` : '../../../images/defaultImage.png'}
                                        alt={`Thumbnail ${i + 1}`}
                                        className=""
                                    />
                                </div>
                            ))}
                        </div>
                        <div className="col-sm-10 col-12 image_magnify_box">
                            {currentImage && (
                                <ReactImageMagnify
                                    {...{
                                        smallImage: {
                                            alt: 'Product Image',
                                            isFluidWidth: true,
                                            src: currentImage,
                                        },
                                        largeImage: {
                                            src: currentImage,
                                            width: 1200,
                                            height: 1800,
                                        },
                                        enlargedImageContainerStyle: {
                                            zIndex: 2000,
                                            backgroundColor: '#000',
                                        },
                                        enlargedImageContainerDimensions: {
                                            width: '150%',
                                            height: '150%',
                                        },
                                        isHintEnabled: false,
                                        shouldUsePositiveSpaceLens: true,
                                    }}
                                />
                            )}
                        </div>
                        <div className="imge_wepper d-sm-none d-block d-flex col-12 mt-3" style={{ gap: '10px' }}>
                            {(
                                (filteredProductSkuDtos && filteredProductSkuDtos.length > 0 && filteredProductSkuDtos[0]?.productImageDtos?.length > 0)
                                    ? filteredProductSkuDtos[0]?.productImageDtos
                                    : productDetail?.productImageDtos
                            )?.slice(0, 6).map((item, i) => (
                                <div
                                    className={`col-2 img_book_wrapper ${i === currentIndex ? 'slick-current' : ''}`}
                                    key={i}
                                    onClick={() => handleVerticalClick(i)}
                                >
                                    <img
                                        src={item?.imgPath ? `${imageUrl}${item.imgPath}` : '../../../images/defaultImage.png'}
                                        alt={`Thumbnail ${i + 1}`}
                                        className=""
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ImageSection;
